import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ApplyForm } from "../../service/guest/guest";
import { GuestService } from "../../service/guest/guest.service";

@Component({
  selector: 'app-guest',
  templateUrl: './guest.component.html',
  styleUrls: ['./guest.component.scss'],
  providers: [GuestService]
})
export class GuestComponent {
  id: number;
  date = {
    day: '',
    hour: '',
    minute: '',
  };
  private hours: string[] = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21'];
  form: ApplyForm;
  loading: Boolean = false;

  constructor(private guestService: GuestService,
    private router: Router,
    private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.id = params['id'] ? +params['id'] : null;
      this.date.day = moment().format('YYYY-MM-DD');

      if (this.id) {
        this.guestService.getById(this.id).subscribe(
          form => this.form = form
        )
      } else {
        this.form = new ApplyForm();
      }
    })
  }

  onNumberCheck(phone: string) {
    return phone.replace(/[^0-9\.]+/g, '');
  }

  onClickBack() {
    window.scrollTo(0, 0);
    window.history.back();
  }

  onUpdate(form: ApplyForm) {
    let elapsed = moment(`${this.date.day} ${this.date.hour}`, 'YYYY-MM-DD hh').diff(moment())

    if (elapsed < 0) {
      window.alert('방문시간을 현재 이후로 선택해 주세요.');
      return;
    }
    else if (!form.type) {
      window.alert('방문자 유형을 선택해 주세요.');
      return;
    } else if (!form.agree) {
      window.alert('개인정보 수집을 동의해 주세요.');
      return;
    } else if (!form.location) {
      window.alert('방문지점을 선택해 주세요.');
      return;
    } else if (!this.date.day) {
      window.alert('방문일자를 선택해 주세요.');
      return;
    } else if (!this.date.hour) {
      window.alert('방문시간을 선택해 주세요.');
      return;
    } else if (!form.phone) {
      window.alert('연락처를 입력해 주세요.');
      return;
    }

    form.name = "";
    const ipt = { ...form }

    delete ipt.agree
    ipt.date = this.date.day
    ipt.time = `${this.date.hour}:00`
    ipt.location = { key: ipt.location }
    this.loading = true;

    this.guestService.applyGuest(ipt).subscribe(
      res => {
        window.scrollTo(0, 0);
        this.router.navigateByUrl(`/member/guest/${res.id}`);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/member/guest/guest.component.ts